import * as React from 'react'
import { StyleSheet, TouchableOpacity, Text, Image } from 'react-native'
import { Domain } from '../../../core'
import { useNavigate } from '../../../lib/hooks'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderWidth: 1,
    paddingHorizontal: 15,
    paddingVertical: 20,
    marginBottom: 8,
  },
  title: {
    fontSize: 16,
    alignSelf: 'center',
  },
  arrow: {
    width: 13,
    resizeMode: 'contain',
    paddingBottom: 16,
    position: 'absolute',
    right: 15,
    top: '37%'
  },
})

type Props = {
  prefecture: Domain.Prefecture.Entity
}

export default function Card(props: Props) {
  const { prefecture } = props

  const prefectureCd = prefecture?.prefectureCd
  const needsToShowMunicipality = prefecture?.needsToShowMunicipality

  const navigateToCityInput = useNavigate(`/city-input/${prefectureCd}`)
  const navigateToNearbyStoreInput = useNavigate(`/nearby-store-input/${prefectureCd}`)

  const handleRedirect = React.useCallback(() => {
    if (needsToShowMunicipality) {
      sessionStorage.setItem('prefectureName', prefecture?.prefectureName)
      navigateToCityInput()
    } else {
      navigateToNearbyStoreInput()
    }
  }, [navigateToCityInput, navigateToNearbyStoreInput, needsToShowMunicipality, prefecture])
  
  return (
    <TouchableOpacity style={styles.container} onPress={handleRedirect}>
      <Text style={styles.title}>{prefecture?.prefectureName}</Text>
      <Image source={require('../../../assets/images/next_icon.png')} style={styles.arrow} />
    </TouchableOpacity>
  )
}
